export const DEBUG = process.env.REACT_APP_DEBUG === 'true'

export const DEFAULT_REQUEST_HEADERS = {
	'Content-Type': 'application/json'
}

export const apiHost = process.env.REACT_APP_API_HOST
export const graphqlHost = `${apiHost}/graphql`
export const appId = process.env.REACT_APP_APP_ID
export const routePrefix = process.env.REACT_APP_BASE_PATH || '/onboarding'

export const paymentMethods = [
	{ value: 'credit-card', label: 'Credit Card' },
	{ value: 'apple-pay', label: 'Apple Pay' },
	{ value: 'google-pay', label: 'Google Pay' },
	{ value: 'paypal', label: 'PayPal' }
]

// export const dotts = '...'
export const LOGO_IMAGE = process.env.REACT_APP_LOGO_IMAGE || ''

export const ONBOARDING_COUPON = process.env.REACT_APP_NEW_CUSTOMER_COUPON || ''

export const landingBoxes = [
	{
		title: 'Real food',
		text: 'Human-grade<br />made fresh.',
		image: 'fork-spoon.png',
		sx: {
			image: {
				width: 94,
				height: 83
			}
		}
	},
	{
		title: 'Tailored Plan',
		text: 'Pre-portioned packs<br />Warm open and pour',
		image: 'bowl.png',
		sx: {
			image: {
				width: 124,
				height: 66
			}
		}
	},
	{
		title: 'Convenient Deliveries',
		text: 'Skip the store.<br />We deliver to your door.',
		image: 'delivery.png',
		sx: {
			image: {
				width: 65,
				height: 91
			}
		}
	}
]
